module.exports = __webpack_public_path__ + "static/media/phones-dashboard.62a20ac1.png";